import {
    ACTION_TYPES,
    CONDITIONS,
    CONDITIONS_VALUE,
    CONDITION_NAME,
    OPERATORS
} from "../misc/constants";
import { Col, Row } from "reactstrap";

import AsyncSelectField from "@components/fields/react-select/async-select";
import CommonModal from "@components/ui-components/modal";
import FieldArrays from "@components/fields/field-arrays";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import LoadingButton from "@components/ui-components/loading-button";
import Select from "@components/fields/react-select/select";
import SingleDatePicker from "@components/fields/date-picker/single-picker";
import size from "lodash/size";
import { useFieldArray } from "react-hook-form";
import useFilters from "@src/views/common/hooks/use-filter";
import useUpsert from "./use-upsert";

const UpsertPlaybooks = (props) => {
    const { modalConfig, handleModal } = props;
    const isEdit = !!size(modalConfig.row);

    const { onSubmit, methods, updateLoading, isDirty, loading } =
    useUpsert(props);
    const { loadAsyncOptions } = useFilters();

    const {
        control,
        watch,
        formState: { errors }
    } = methods;

    const { fields, append, remove } = useFieldArray({
        name: "conditions",
        control
    });

    const {
        fields: actionFields,
        remove: removeAction,
        insert: insertAction
    } = useFieldArray({
        name: "flow_steps",
        control
    });
    const defaultStep = {
        name       : "new_task",
        props_name : "",
        description: "",
        due_date   : new Date(),
        survey_id  : ""
    };

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the playbook which you wish to create"
            },
            rightChild: (
                <Row>
                    <InputField
                        id="name"
                        name="name"
                        label="Name"
                        required
                        control={control}
                        errors={errors}/>
                    <InputField
                        label="Description"
                        required
                        id="description"
                        name="description"
                        control={control}
                        errors={errors}/>
                </Row>
            )
        },
        {
            leftChild: {
                title: "Start Trigger"
            },
            rightChild: (
                <FieldArrays
                    render={(index) => {
                        const condition = watch(`conditions.${index}.name`);
                        return (
                            <>
                                <Col md={2}>
                                    <Select
                                        label="Condition"
                                        required
                                        id="condition"
                                        name={`conditions.${index}.condition`}
                                        control={control}
                                        errors={errors?.conditions?.[index]}
                                        options={CONDITIONS}/>
                                </Col>
                                <Col md={3}>
                                    <Select
                                        label="Condition Name"
                                        required
                                        id="name"
                                        name={`conditions.${index}.name`}
                                        control={control}
                                        errors={errors?.conditions?.[index]}
                                        options={CONDITION_NAME("attribute")}/>
                                </Col>
                                <Col md={3}>
                                    <Select
                                        label="Operator"
                                        required
                                        id="operator"
                                        name={`conditions.${index}.operator`}
                                        control={control}
                                        errors={errors?.conditions?.[index]}
                                        options={OPERATORS(condition)}/>
                                </Col>

                                <Col md={2}>
                                    {condition !== "billing_frequency" ? (
                                        <InputField
                                            required
                                            id="value"
                                            name={`conditions.${index}.value`}
                                            type="number"
                                            label="Value"
                                            control={control}
                                            errors={errors?.conditions?.[index]}
                                            prefix={condition === "mrr" ? { txt: "$" } : undefined}
                                            suffix={
                                                condition === "next_billing_date" ? { txt: "Days" } : undefined
                                            }/>
                                    ) : (
                                        <Select
                                            label="Value"
                                            required
                                            id="value"
                                            name={`conditions.${index}.value`}
                                            control={control}
                                            errors={errors?.conditions?.[index]}
                                            options={CONDITIONS_VALUE}/>
                                    )}
                                </Col>
                            </>
                        );
                    }}
                    fields={fields}
                    subject="playbooks"
                    handleAppend={() => append({
                        condition: "",
                        name     : "",
                        operator : "",
                        value    : 0
                    })
                    }
                    handleRemove={(index) => {
                        remove(index);
                    }}
                    disabledAppend={false}
                    disabledRemove={false}/>
            )
        },
        {
            leftChild: {
                title: "Actions"
            },
            leftChildProps: { lg: 3 },
            rightChild    : (
                <FieldArrays
                    className="border p-1"
                    render={(index) => {
                        const actionType = watch(`flow_steps.${index}.name`);

                        return (
                            <Col lg={9}>
                                {/* <Row lg={8}>
                                    <h3>{index + 1}.</h3>
                                </Row> */}
                                <Row>
                                    <Col md={3}>
                                        <Select
                                            label="Type"
                                            required
                                            id="name"
                                            name={`flow_steps.${index}.name`}
                                            control={control}
                                            errors={errors?.flow_steps?.[index] || {}}
                                            options={ACTION_TYPES}/>
                                    </Col>

                                    {actionType !== "send_survey" ? (
                                        <>
                                            <Col lg={3}>
                                                <InputField
                                                    label="Name"
                                                    id="props_name"
                                                    name={`flow_steps.${index}.props_name`}
                                                    required
                                                    control={control}
                                                    errors={errors?.flow_steps?.[index] || {}}/>
                                            </Col>
                                            <Col md={3}>
                                                <InputField
                                                    label="Description"
                                                    id="description"
                                                    name={`flow_steps.${index}.description`}
                                                    required
                                                    control={control}
                                                    errors={errors?.flow_steps?.[index] || {}}/>
                                            </Col>

                                            <Col lg={3}>
                                                <SingleDatePicker
                                                    label="Due Date"
                                                    id="due_date"
                                                    name={`flow_steps.${index}.due_date`}
                                                    format="yyyy-MM-dd"
                                                    required
                                                    errors={errors?.flow_steps?.[index] || {}}
                                                    control={control}
                                                    minDate={new Date()}/>
                                            </Col>
                                        </>
                                    ) : (
                                        <Col lg={3}>
                                            <AsyncSelectField
                                                loadOptions={(value, callback) => loadAsyncOptions({
                                                    value,
                                                    callback,
                                                    type       : "survey",
                                                    statusCheck: true
                                                })
                                                }
                                                defaultOptions
                                                id="survey_id"
                                                required
                                                isClearable
                                                errors={errors?.flow_steps?.[index] || {}}
                                                label="Survey"
                                                name={`flow_steps.${index}.survey_id`}
                                                control={control}/>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        );
                    }}
                    fields={actionFields}
                    subject="playbooks"
                    handleAppend={false}
                    handleRemove={removeAction}
                    extraActions={(index) => (
                        <>
                            <LoadingButton
                                color="primary"
                                onClick={() => insertAction(index, defaultStep)}
                                tooltip="Add Above"
                                icon="arrow-up-bold"/>
                            <LoadingButton
                                color="primary"
                                onClick={() => insertAction(index + 1, defaultStep)}
                                tooltip="Add Below"
                                icon="arrow-down-bold"/>
                            {size(actionFields) > 1 && (
                                <LoadingButton
                                    color="danger"
                                    onClick={() => removeAction(index)}
                                    title="Remove"
                                    className=""
                                    icon="delete"/>
                            )}

                        </>
                    )}
                    disabledAppend={true}
                    disabledRemove={true}/>
            )
        }
    ];
    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Playbook`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="fullScreen"
            isDirty={isDirty}
            loading={loading}
            handleModal={handleModal}
            isOpen={modalConfig.isOpen}/>
    );
};

export default UpsertPlaybooks;
